import React from 'react';
import logo from './imgs/CONNCEPTS-LOGO-test.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-grid">
          <div className="footer-col footer-brand">
            <img src={logo} alt="Conncepts" className="footer-logo" />
            <p className="footer-text">Independent Epicor ERP consulting, based in Spring Hill, Florida.</p>
          </div>

          <div className="footer-col">
            <h2 className="footer-heading">Contact</h2>
            <a href="mailto:sales@conncepts.pro" className="footer-link">sales@conncepts.pro</a>
            <a href="tel:8133361662" className="footer-link">813-336-1662</a>
          </div>

          <div className="footer-col">
            <h2 className="footer-heading">Services</h2>
            <a href="/why-me" className="footer-link">Why me</a>
            <a href="/customizations" className="footer-link">Customizations and support</a>
            <a href="/integrations" className="footer-link">Integrations</a>
            <a href="/pricing" className="footer-link">Pricing</a>
          </div>

          <div className="footer-col">
            <h2 className="footer-heading">Free tools</h2>
            <a href="/utilities" className="footer-link">Epicor utilities</a>
            <a href="/schema-visualizer" className="footer-link">Schema visualizer</a>
            <a href="/GameWrapper" className="footer-link">ERP Blaster game</a>
            <a href="https://www.erpulse.net" target="_blank" rel="noopener noreferrer" className="footer-link">ERPulse monitoring</a>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Conncepts Consulting</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
